import { render, staticRenderFns } from "./PopoverAddNewUser.vue?vue&type=template&id=333a4390&scoped=true"
import script from "./PopoverAddNewUser.vue?vue&type=script&lang=js"
export * from "./PopoverAddNewUser.vue?vue&type=script&lang=js"
import style0 from "./PopoverAddNewUser.vue?vue&type=style&index=0&id=333a4390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333a4390",
  null
  
)

export default component.exports